<template>
  <div :class="{ 'o-card': !tab }">
    <Table
      no-card
      :title="$t(`${name}.title`)"
      :description="$t(`${name}.description`)"
      i18n
      :loading="loading"
      :status="$status.auxiliaryCoolingEquipment"
      :items="items"
      checkable
      :checkValue="checkedList"
      @change:sort="SET_CHANGE_SORT"
      @change:checkedList="checkedList = $event"
      @change:selectAllWithoutPage="SET_CHECKED_ALL"
      :headers="headers"
      :page="page"
      :count="count"
      :pages="pages"
      no-search
      @change:page="setChangedPage"
      :searchPlaceholder="$t(`${name}.searchPlaceholder`)"
    >
      <template #new-button>
        <div class="u-display-flex u-width-100% u-justify-content-flex-end">
          <ExcelExport
            :fileName="`${name}-export-${date()}`"
            :fields="exportFields"
            :data="checkedList.length > 0 ? checkedList : items"
          >
            <template #button="{ showExcell }">
              <Button
                @click="showExcell()"
                variant="light-success"
                class="u-margin-right-xsmall"
              >
                <i class="icofont-arrow-up"></i> {{ $t("common.export") }}
              </Button>
            </template>
          </ExcelExport>

          <Button variant="light-primary" @click="newMainProject = true">
            + {{ $t(`${name}.add`) }}
          </Button>
        </div>
      </template>
      <template #title="{ item }">
        <div class="u-display-flex u-align-items-center">
          <div class="u-margin-right-small">
            <img
              :src="getImage(item.auxiliaryCoolingEquipmentInfo.imagePath)"
              width="50"
              :alt="item.title"
              class="u-radius-g"
            />
          </div>
          <div>
            <div class="u-color-primary">
              {{ item.auxiliaryCoolingEquipmentInfo.title }}
            </div>
            <div>
              {{ $date.format(item.auxiliaryCoolingEquipmentInfo.createdDate) }}
            </div>
          </div>
        </div>
      </template>
      <template #dimensions="{ item }">
        <div>
          {{ $t("auxiliaryCoolingEquipment.width") }} :
          {{ item.auxiliaryCoolingEquipmentInfo.width }}
        </div>
        <div>
          {{ $t("auxiliaryCoolingEquipment.height") }} :
          {{ item.auxiliaryCoolingEquipmentInfo.height }}
        </div>
        <div>
          {{ $t("auxiliaryCoolingEquipment.depth") }} :
          {{ item.auxiliaryCoolingEquipmentInfo.depth }}
        </div>
      </template>
      <template #chip="{ item }">
        {{ item.auxiliaryCoolingEquipmentInfo.chip }}
      </template>
      <template #brand="{ item }">
        {{ item.auxiliaryCoolingEquipmentInfo.brand }}
      </template>
      <template #model="{ item }">
        {{ item.auxiliaryCoolingEquipmentInfo.model }}
      </template>
      <template #action="{ item }">
        <div
          class="u-display-flex u-align-items-center u-justify-content-flex-end"
        >
          <Button variant="light-primary" @click="showDetail(item)">
            <i class="icofont-edit u-margin-right-xsmall"></i>
            {{ $t("common.edit") }}
          </Button>
          <Button variant="light-danger" @click="REMOVE_TO(item)">
            <i class="icofont-trash"></i>
          </Button>
        </div>
      </template>
    </Table>
    <RemoveModal @ok="REMOVE_ITEM" v-model="removeModal.status"></RemoveModal>

    <AuxiliaryCoolingEquipmentFormEdit
      edit
      @refresh="getItemsOfPage"
      v-model="showDetailModal.status"
      key="edit"
      :form="showDetailModal?.item?.auxiliaryCoolingEquipmentInfo || {}"
    ></AuxiliaryCoolingEquipmentFormEdit>
    <AuxiliaryCoolingEquipmentForm
      v-model="newMainProject"
      :projectId="project.id"
      @refresh="getItemsOfPage"
      key="new"
    ></AuxiliaryCoolingEquipmentForm>
  </div>
</template>

<script>
import Table from "@/components/Base/Table/index.vue";
import DateHelper from "@/helpers/date";
import { mapGetters } from "vuex";
import Button from "@/components/Base/Button.vue";
import RemoveModal from "@/components/Shared/RemoveModal/index.vue";
import ExcelExport from "@/components/Base/ExcelExport.vue";
import Requests from "@/services/Requests";
import auxiliaryCoolingEquipmentExportFields from "./export";
import AuxiliaryCoolingEquipmentForm from "./AuxiliaryCoolingEquipmentForm.vue";
import AuxiliaryCoolingEquipmentFormEdit from "@/components/AuxiliaryCoolingEquipment/AuxiliaryCoolingEquipmentForm.vue";
import $api from "@/services/Api";
export default {
  components: {
    RemoveModal,
    Table,
    Button,
    ExcelExport,
    AuxiliaryCoolingEquipmentForm,
    AuxiliaryCoolingEquipmentFormEdit,
  },
  mixins: [auxiliaryCoolingEquipmentExportFields],
  props: {
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
    project: {
      type: Object,
      default: () => {
        return {};
      },
    },
    noFilter: {
      type: Boolean,
      default: false,
    },
    tab: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      name: "auxiliaryCoolingEquipment",
      checkedList: [],
      showLockedModal: false,
      showRemoveModal: false,
      newMainProject: false,
      filter: {},
      sort: {},
      get: {
        title: "auxiliaryCoolingEquipment",
        dispatch: "getAuxiliaryCoolingEquipment",
      },
      update: {
        title: "updateAuxiliaryCoolingEquipment",
        dispatch: "updateAuxiliaryCoolingEquipment",
        lockedStatus: "isLocked",
      },
      remove: {
        title: "removeAuxiliaryCoolingEquipment",
        dispatch: "removeAuxiliaryCoolingEquipment",
      },
      page: 1,
      search: "",
      items: [],
      loading: true,
      count: 0,
      headers: [
        {
          col: 4,
          sm: 2,
          md: 2,
          lg: 2,
          title: "auxiliaryCoolingEquipment.equipment",
          value: "title",
        },
        {
          col: 4,
          sm: 2,
          md: 2,
          lg: 2,
          title: "auxiliaryCoolingEquipment.brand",
          value: "brand",
        },
        {
          col: 4,
          sm: 2,
          md: 2,
          lg: 2,
          title: "auxiliaryCoolingEquipment.model",
          value: "model",
        },
        {
          col: 4,
          sm: 2,
          md: 2,
          lg: 2,
          title: "auxiliaryCoolingEquipment.chip",
          value: "chip",
        },
        {
          col: 4,
          sm: 1,
          md: 1,
          lg: 1,
          title: "auxiliaryCoolingEquipment.dimensions",
          value: "dimensions",
        },
        {
          col: 12,
          sm: 2,
          md: 2,
          lg: 2,
          align: "right",
          title: "common.action",
          value: "action",
        },
      ],
      removeModal: { status: false, item: {} },
      lockedModal: { status: false, item: {} },
      showDetailModal: { status: false, adminDetailStatus: false, item: null },
    };
  },
  computed: {
    ...mapGetters({
      getActiveUser: "getActiveUser",
    }),
    pages() {
      return Math.ceil(this.count / 10);
    },
    exportFields() {
      if (this.items.length === 0) return {};
      return this.getExcelFields();
    },
  },
  methods: {
    getImage(image) {
      console.log(image, $api.image(image));

      return $api.image(image);
    },
    SET_CHANGE_SORT(headers) {
      const sortedHeaders = headers.filter((item) => item.sort);
      if (sortedHeaders.length === 0) {
        this.sort = {};
        this.getItemsOfPage();
      } else {
        const sort = sortedHeaders[0];
        if (sort.sort.includes("name")) {
          const value = sort.sort.split("-")[1];
          this.sort = {
            sort: value.toUpperCase(),
            sortFilter: "ALPHABETIC",
          };
        } else if (sort.sort.includes("info")) {
          const value = sort.sort.split("-")[1];
          this.sort = {
            sort: value.toUpperCase(),
            sortFilter: "DATE",
          };
        }
        this.getItemsOfPage();
      }
    },
    async SET_CHECKED_ALL(data) {
      if (data) {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: true,
          status: true,
        });
        const response = await Requests.AuxiliaryCoolingEquipment.GetAll({
          query: { page: 1, limit: this.count, search: this.search },
        });
        this.$status.auxiliaryCoolingEquipment = response.message;
        if (response.message === "OK") {
          console.log(response.data);

          this.checkedList = [...response.data.items];
        }
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: false,
        });
      }
    },
    showDetail(item) {
      this.showDetailModal = {
        status: true,
        adminDetailStatus: false,
        item: item,
      };
    },
    showAdminDetail(item) {
      this.showDetailModal = {
        status: false,
        adminDetailStatus: true,
        item: item,
      };
    },
    date(value = new Date()) {
      const date = new DateHelper(this.$i18n.locale);
      return date.format(value);
    },
    SET_LOCKED_DESCRIPTION() {
      return this.lockedModal.item.isLocked ? "unlocked" : "locked";
    },
    REMOVE_TO(item) {
      this.removeModal = {
        status: true,
        item: item,
      };
    },
    async REMOVE_ITEM(loading) {
      loading(true);

      const response = await Requests.ProjectAuxiliaryCoolingEquipment.Delete({
        params: { id: this.removeModal.item.id },
      });
      if (response.message === "OK") {
        this.getItemsOfPage();
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`${this.name}.removeSuccess`),
          variant: "success",
          duration: 2500,
        });
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`${this.name}.removeError`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
    setQuery() {
      const page = Number(this.$route.query.page);
      const search = this.$route.query.search;
      if (!isNaN(page)) this.page = page;
      if (search) this.search = search;
      this.getItemsOfPage();
    },
    async getItemsOfPage() {
      this.loading = true;
      this.removeModal = { status: false, item: {} };
      this.lockedModal = { status: false, item: {} };
      const response = await Requests.ProjectAuxiliaryCoolingEquipment.GetAll({
        query: {
          limit: 10,
          page: this.page,
          search: this.search,
          ...this.filter,
          ...this.sort,
          ...this.query,
        },
      });
      this.$status.auxiliaryCoolingEquipment = response.message;
      if (response.message === "OK") {
        this.items = response.data.items;
        this.count = response.data.count;
      }
      this.loading = false;
    },
    setSearch(search) {
      this.search = search;
      this.page = 1;
      this.$router.replace({
        query: { ...this.$route.query, search: this.search, page: 1 },
      });
      this.getItemsOfPage();
    },
    setChangedPage(page) {
      this.$router.replace({
        query: { ...this.$route.query, page: page },
      });
      this.page = page;
      this.getItemsOfPage();
    },
    setFilter(filter) {
      const filterScoped = {
        type: filter.type || "",
        isLocked:
          filter.isLocked == null
            ? ""
            : filter.isLocked
            ? "true"
            : "false" || "",
        userId: filter.user?.id || "",
        batteryId: filter.batteryId?.id || "",
      };
      // remove
      this.filter = filterScoped;
      this.getItemsOfPage(filterScoped);
    },
  },
  mounted() {
    this.setQuery();
  },
};
</script>

<style></style>
